module.exports = __webpack_public_path__ + "static/media/man-empty.dc95a5c2.png";